// extracted by mini-css-extract-plugin
module.exports = {"card":"dashboardListingCard_card__rIXnU","cardBody":"dashboardListingCard_cardBody__1O_oG","cardHeader":"dashboardListingCard_cardHeader__3qh9r"};